import React, { Component } from "react";
import Game from "./game";
import GameResultDialog from "./components/popup";
import * as api from "./api";
import { Redirect } from "react-router-dom";
import "./App.css";
import Detector from './utils/detector';
import EndedDialog from './popup/endedDialog';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      curRenderDom: null,
      curDomFlag: '0',  // 1 for no game, 0 for game
      gameScore: {},
      initInfoRes: [],
      gameAwardInfo: [] // 本场获得奖励
    };

    const game = new Game(window.data_source_100001226.game, {
      onGameover: () => {
        sessionStorage.setItem(
          "yqs_gameScore",
          JSON.stringify(game.getScore())
        );
        this.setState({ gameScore: game.getScore() });
        setTimeout(() => {
          this._takeReward() // 去抽奖
        }, 618)
      }
    });
    this.gameObj = game;

    this.enter();
  }

  enter () {
    const isJrApp = navigator.userAgent.toLowerCase().match(/jdjr-app/i);
    if(!isJrApp) {// 站外
      this._judgeIsNewUser()
    } else {// 站内
      this._judgeIsCanJoin('', '2'); // 判断是否可以参与
    }
  }

  _judgeIsCanJoin(strCode, flag) {
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.judgeIsCanJoin({reqData: JSON.stringify(param)}).then(res => {
      sessionStorage.setItem('yqs_initInfo_res', JSON.stringify(res))
      if (res.resultCode === -1) { // 接口异常
        this.setState({
          curRenderDom: <GameResultDialog sysCode={'-1'} closeCallback={(obj) => {this._closeCallback(obj)}}/>,
          curDomFlag: '0'
        });
        this.gameObj.preStart()
        return
      }
      let {code} = res.resultData
      // this.setState({initInfoRes: res})
      console.log('strCode__code:::', strCode, code)
      if (code === '10004') {
        this.setState({
          curRenderDom: <GameResultDialog sysCode={code} closeCallback={(obj) => {this._closeCallback(obj)}}/>,
          curDomFlag: '0'
        });
        this.gameObj.preStart()
        console.log('活动已结束。。。')
        return
      }
      if (strCode === '00000hby' && flag === '1') {// 站外新用户 首次进游戏先弹新人机会弹窗
        this.setState({
          curRenderDom: <GameResultDialog sysCode={code} isNewUser={flag} joinGameCallback={(obj) => {this._joinGameCallback(obj)}}/>,
          curDomFlag: '0'
        });
        this.gameObj.preStart()
        console.log('新用户 首次进游戏')
        return
      }
      // 站外新用户 非首次进游戏直接弹新人奖励弹窗（不玩游戏）
      if (strCode === '10005hby' && flag === '2') {
        sessionStorage.setItem(
          "yqs_gameScore",
          JSON.stringify({red_pocket: 1, coin: 0})
        );
        this.setState({
          curRenderDom: <GameResultDialog sysCode={strCode} isNewUser={flag} joinGameCallback={(obj) => {this._joinGameCallback(obj)}}/>,
          curDomFlag: '0'
        });
        this.gameObj.preStart()
        console.log('新用户 非首次进游戏')
        return
      }
      // 不可参与判断: 非当前时段或当前时间段超过抽奖次数
      if (['10001hby', '10002hby'].includes(code)) {
        // this.gameObj.destroy() // 关闭游戏 销毁canvas
        this.gameObj.preStart()
        this.setState({
          curDomFlag: '1'
        });
      } else { // 包含风控用户
        this.gameObj.start();
      }
    })
  }

  _takeReward() {
    let param = {
      source: "aaaccc",
      pageType: 5,
      actCode: Detector.interface_ActCode
    }
    api.takeReward1({reqData: JSON.stringify(param)}).then(res => {
      let { code, data } = res.resultData
      if (['00000hby','10001hby'].includes(code)) {
        // 当前游戏获得奖励信息
        sessionStorage.setItem('yqs_curGame_awardInfo', JSON.stringify(data))
        let dialogDom = this._rtnDialogDom(code)
        this.setState({
          gameAwardInfo: data,
          curRenderDom: dialogDom,
          curDomFlag: '0'
        });
      } else if (code === '10004zt') {
        sessionStorage.setItem('yqs_curGame_awardInfo', '')
        // this._rtnDialogDom(code);
        this.setState({
          curRenderDom: <GameResultDialog sysCode={code} closeCallback={(obj) => {this._closeCallback(obj)}}/>,
          curDomFlag: '0'
        });
      } else if (code === '10004') { // 活动已结束
        this.setState({
          curRenderDom: <EndedDialog closeCallback={(obj) => this._handleCloseCallback(obj)}/>,
          curDomFlag: '0'
        });
      } else { // 跳托底页
        this.gameObj.reset() // 关闭游戏 销毁canvas
        this.setState({
          curDomFlag: '1'
        });
      }
    })
  }

  // 关闭弹窗
  _handleCloseCallback(obj) {
    this.gameObj.reset() // 关闭游戏 销毁canvas
    this.setState({
      curDomFlag: '1'
    })
  }

  _loadShareInfo(strCode){
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.myShareInfo({reqData: JSON.stringify(param)}).then(res => {
      let { code, data } = res.resultData
      console.log('myShareInfo_resultData:::', res.resultData)
      if (code === '00000hby') {
        if (data.isjoin === '1') {
          this.gameObj.reset()
          console.log('再次进入游戏_reset一次游戏_data.isjoin:::', data.isjoin)
        }
        if (strCode === '10005hby') {
          // 当前游戏获得奖励信息
          sessionStorage.setItem('yqs_sharedTimes', data.isjoin)
          let awardInfo = {
            reward: data.myRewardList[0],
            nextornow: data.nextornow,
            globalfight: '75.6%'
          }
          sessionStorage.setItem('yqs_curGame_awardInfo', JSON.stringify(awardInfo))
          this._judgeIsCanJoin(strCode, '2'); // 判断是否可以参与
        }
      }
    })
  }

  _rtnDialogDom=(code) => {
    // console.log('this.state.initInfoRes:::', this.state.initInfoRes)
    return(<GameResultDialog sysCode={code} closeCallback={(obj) => {this._closeCallback(obj)}} gameAward={this.state.gameAwardInfo}/>)
  }

  _closeCallback=(obj) => {
    console.log('obj.isShow:::', obj.isShow)
    window.$('body').find('.popup_dialog').css('display', 'none')
    if (!obj.isShow) {
      console.log('关闭游戏 销毁canvas')
      // this.gameObj.destroy() // 关闭游戏 销毁canvas
      this.gameObj.reset()
      this.setState({curDomFlag: '1'})
    }
  }

  _joinGameCallback=(obj) => {
    if(obj.isJoin) {
      /**
       * 1. 关闭新用户奖励弹窗&开始游戏
       * 2. 站内分享弹窗第一次分享时可再次玩游戏
       */
      // alert('分享成功再次玩游戏')
      this.gameObj.reset()
      this.setState({
        curRenderDom: null,
        curDomFlag: '0'
      });
      this.gameObj.start();
    }
  }

  _judgeIsNewUser() {
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.isShareRoleInfo({reqData: JSON.stringify(param)}).then(res => {
      if (res.resultCode === -1) { // 接口异常
        this.setState({
          curRenderDom: <GameResultDialog sysCode={'-1'} closeCallback={(obj) => {this._closeCallback(obj)}}/>,
          curDomFlag: '0'
        });
        return
      }
      console.log('判断新用户...')
      let {code} = res.resultData
      if (code === '00000hby') { // 新用户首次进入游戏
        this._judgeIsCanJoin(code, '1'); // 判断是否可以参与
      } else { // 站外老用户打开活动链接->进入托底页->直接唤起金融App
        // 新用户非首次进入游戏 直接给新人奖励
        console.log('isShareRoleInfo_code:::', code)
        if (code === '10005hby') {
          console.log('新用户非首次:::')
          this._loadShareInfo(code) // 获取用户首次获得的奖励
        } else {
          this._loadShareInfo(code)
          if (sessionStorage.getItem('yqs_handleJoinGame_flag')==='1') {
            window.location.href = `https://m.jr.jd.com/spe/downloadApp/index.html?id=1192&activityid=1158`
          } else { // 老用户站外进游戏页->跳托底页
            // this.gameObj.destroy() // 关闭游戏 销毁canvas
            this.gameObj.reset()
            this.setState({
              curDomFlag: '1'
            });
          }
        }
      }
    })
  }

  render() {
    let { curDomFlag, curRenderDom } = this.state;

    return curDomFlag === '1' ? (<Redirect to="/main"/>) : <div>{curRenderDom}</div>;
  }
}

export default App;
